import React from 'react';
import { useDataExports, useI18N, useInAppMessage } from '../../../../hooks';
import { ExportBtnExcel } from "../../../molecules";
import useDataGrid from '../../data-grid/use-data-grid';

interface Props {
    className?: string;
    iconOnly?: boolean;
    disabled?: boolean;
}
export default function ExportToExcel({ className, iconOnly, disabled }: Props) {
    const i18n = useI18N();
    const { localeKey } = i18n;
    const grid = useDataGrid();
    const exports = useDataExports();
    const message = useInAppMessage();
    const isDisabled = (disabled) ? true : (grid.isLoading) ? true : false;
    const onExport = (count: number, data: any[]) => {
        const resolveExportMSG = () => message.createSuccess(`Exported ${count} ${(count === 1) ? 'row' : 'rows'}!`, { dismiss: 5000 });
        message.createLoading(`Exporting ${count} ${(count === 1) ? 'row' : 'rows'}...`);
        setTimeout(() => {
            exports.exportToExcel(data, grid.columnFields, resolveExportMSG);
        }, 2000);
    }
    const selectedOption = (grid.isOnRowSelect) ? [{
        label: `(${grid.selectedRows.length || 0}) ${i18n.translateThis('Selected', i18n.localize.selected)}`,
        onClick: () => onExport(grid.selectedRows.length || 0, grid.selectedRows)
    }] : []

    const customOptions = (typeof grid.exports.customOptions === 'object') ?
        grid.exports.customOptions.filter(
            (item) => {
                if (item.type === 'excel') {
                    return item;
                }
            }) : [];

    const options = [
        {
            label: `(${grid.cachedTableData.length}) Fetched`,
            onClick: () => onExport((typeof grid.totalDataCount === 'number') ? grid.cachedTableData.length : 0, grid.cachedTableData)
        },
        ...selectedOption,
        ...customOptions
    ]

    return (
        <>
            <ExportBtnExcel
                className={className}
                small
                data={grid.tableData}
                fields={grid.columnFields}
                options={options as any}
                iconOnly={iconOnly}
                disabled={isDisabled}
            />
        </>
    )
}